var map = {
	"./brandConfig.ameland.tsx": 802,
	"./brandConfig.campercontact.tsx": 803,
	"./brandConfig.oberon.tsx": 804,
	"./brandConfig.qualitylodgings.tsx": 805,
	"./brandConfig.schier.tsx": 806,
	"./brandConfig.terschelling.tsx": 807,
	"./brandConfig.texel.tsx": 808,
	"./brandConfig.visitwadden.tsx": 809,
	"./brandConfig.wadden.tsx": 810,
	"./brandConfig.waterland.tsx": 811,
	"./brandConfig.zandvoort.tsx": 812
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 801;